export const BrandMark = () => (
  <svg viewBox="0 0 120 82" role="img" aria-hidden="true">
    <path d="M12 70 Q60 51 108 70" fill="none" stroke="currentColor" strokeWidth="3" />
    <g strokeLinecap="round">
      <path d="M60 60 L60 16" stroke="#075E45" strokeWidth="7" />
      <path d="M46 61 L33 27" stroke="#075E45" strokeWidth="6" />
      <path d="M74 61 L87 27" stroke="#075E45" strokeWidth="6" />
      <path d="M34 64 L17 40" stroke="#075E45" strokeWidth="5" />
      <path d="M86 64 L103 40" stroke="#075E45" strokeWidth="5" />
      <path d="M51 61 L45 34" stroke="#C9A45C" strokeWidth="5" />
      <path d="M69 61 L75 34" stroke="#C9A45C" strokeWidth="5" />
      <path d="M25 65 L9 50" stroke="#075E45" strokeWidth="4" />
      <path d="M95 65 L111 50" stroke="#075E45" strokeWidth="4" />
      <path d="M60 15 L60 7" stroke="#C9A45C" strokeWidth="5" />
    </g>
    <g fill="#075E45">
      <circle cx="60" cy="7" r="5" />
      <circle cx="33" cy="27" r="4.5" />
      <circle cx="87" cy="27" r="4.5" />
      <circle cx="17" cy="40" r="4" />
      <circle cx="103" cy="40" r="4" />
      <circle cx="9" cy="50" r="3.5" />
      <circle cx="111" cy="50" r="3.5" />
      <circle cx="45" cy="34" r="4" fill="#C9A45C" />
      <circle cx="75" cy="34" r="4" fill="#C9A45C" />
    </g>
  </svg>
);

export const LogoMark = ({ size = 34 }) => (
  <span style={{ display: "inline-block", width: size, height: (size * 82) / 120, color: "#075e45" }} aria-hidden="true">
    <BrandMark />
  </span>
);
